import styled from 'styled-components';

export const Container = styled.div({
  width: '100%',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',

  '&.drawing-tabs': {
    maxHeight: '90%',
  },
});

export const CanvasWrapper = styled.div({
  position: 'relative',
  height: '100%',
});

export const CanvasWrapperPreviews = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  position: 'absolute',
  bottom: '10rem',
  right: '10rem',
  alignItems: 'baseline',
});
